import React from "react";
import styles from "./ResumeTemplateProfessional.module.css";
import icon1 from "../../../../assets/images/resume-img/email-icon.png";
import icon2 from "../../../../assets/images/resume-img/phone-icon.png";
import icon3 from "../../../../assets/images/resume-img/location-icon.png";
import icon4 from "../../../../assets/images/resume-img/linkedin-icon.png";
import icon5 from "../../../../assets/images/resume-img/skype-icon.png";
import {
  dataUrl,
  getJobLocationById,
  getWorkExpText,
  toArray,
} from "../../../../helpers/common";
import {
  getEndData,
  getStartData,
} from "../../../Account/Candidate/MyProfile/ExperienceJourney";
import WebsiteLogo from "../../../../helpers/WebsiteLogo";
import { getCertificationValidity } from "..";

const ProfileImage = ({ formData }) => (
  <div className={styles.profileSection}>
    <div className={styles.profileImage}>
      <img
        src={`${formData?.profile_picture}`}
        alt={formData?.name || "Profile"}
        className={styles.profileImg}
      />
    </div>
  </div>
);

const Skills = ({ skills }) => {
  // 1. Extract raw items array safely
  const rawList = Array.isArray(skills)
    ? skills
    : skills?.skills || skills?.additional_fields?.skills || skills;

  // 2. Convert to array if string, or keep as array
  let parsedArray = [];
  if (typeof rawList === "string") {
    parsedArray = toArray(rawList, ","); // split by comma if string
  } else if (Array.isArray(rawList)) {
    parsedArray = rawList;
  } else {
    parsedArray = toArray(rawList);
  }

  // 3. Normalize items to plain strings (extract name/skill_name if object)
  const skillsArr = parsedArray
    .map((item) => {
      if (typeof item === "string") return item.trim();
      if (typeof item === "object" && item !== null) {
        return (
          item?.skill_name ||
          item?.name ||
          item?.skill ||
          item?.title ||
          ""
        ).trim();
      }
      return "";
    })
    .filter(Boolean) // Filter out empty strings
    .slice(0, 6);

  if (!skillsArr.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        SKILLS
      </h2>
      <div className={styles.skillsList}>
        {skillsArr.map((skill, index) => (
          <span className={styles.skillTag} key={index}>
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

const Languages = ({ languages }) => {
  const languagesArr = toArray(languages)?.slice(0, 6);
  if (!languagesArr?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        LANGUAGES
      </h2>
      {languagesArr.map((language, index) => (
        <div className={styles.languageItem} key={index}>
          <div className={styles.languageName}>{language}</div>
          <div className={styles.languageLevel}>
            Professional Working Proficiency
          </div>
        </div>
      ))}
    </div>
  );
};

const Certificates = ({ certifications }) => {
  if (!certifications?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        CERTIFICATES
      </h2>
      {certifications?.map((cert, index) => (
        <div className={styles.certificateItem} key={index}>
          <a
            href={cert?.additional_fields?.url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.certificateName}
          >
            {cert?.additional_fields?.title || cert?.title || cert?.name}
            <i
              className={`mdi mdi-open-in-new fs-15 ms-2 ${styles.certificateIcon}`}
            ></i>
          </a>
          <div className={styles.certificateOrg}>
            {cert?.additional_fields?.organization ||
              cert?.organization ||
              "Organization"}
          </div>

          <div className={styles.certificateOrg}>
            {getCertificationValidity(cert)}
          </div>
        </div>
      ))}
    </div>
  );
};

const Awards = ({ awards }) => {
  if (!awards?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        HONOR AWARDS
      </h2>
      {awards.map((award, index) => (
        <div className={styles.awardItem} key={index}>
          <div className={styles.awardName}>
            {typeof award === "string" ? award : award?.name || award?.title}
          </div>
          <div className={styles.awardOrg}>
            {award?.organization || "Organization"}
          </div>
        </div>
      ))}
    </div>
  );
};

const Interests = ({ interests }) => {
  const interestsArr = toArray(interests)?.slice(0, 4);
  if (!interestsArr?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        INTERESTS
      </h2>
      <div className={styles.interestsList}>
        {interestsArr.map((interest, index) => (
          <div className={styles.interestItem} key={index}>
            <span className={styles.interestIcon}></span>
            <span>{interest}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Header = ({ formData, jobLocations }) => {
  console.log("=== DEBUG: Header Component ===");
  console.log("Header formData:", formData);
  console.log("Header designation:", formData?.designation);
  console.log("Header jobLocations:", jobLocations);

  const locationText = formData?.location
    ? getJobLocationById(formData.location, jobLocations)
    : "";
  console.log("Resolved Location Text:", locationText);

  return (
    <div className={styles.header}>
      <h1 className={styles.name}>{formData?.name || "Your Name"}</h1>
      <h2 className={styles.jobTitle}>
        {formData?.designation || "Your Title"}
      </h2>
      {formData?.details && (
        <p className={styles.summary}>{formData.details}</p>
      )}

      <div className={styles.contactInfo}>
        <div className={styles.contactColumn}>
          {formData?.email && (
            <div className={styles.contactItem}>
              <img src={icon1} alt="email" className={styles.contactIcon} />
              <span>{formData.email}</span>
            </div>
          )}
          {formData?.location && (
            <div className={styles.contactItem}>
              <img src={icon3} alt="location" className={styles.contactIcon} />
              <span>{locationText}, India</span>
            </div>
          )}
          {formData?.skype && (
            <div className={styles.contactItem}>
              <img src={icon5} alt="skype" className={styles.contactIcon} />
              <span>{formData.skype}</span>
            </div>
          )}
        </div>

        <div className={styles.contactColumn}>
          {formData?.mobile_number && (
            <div className={styles.contactItem}>
              <img src={icon2} alt="phone" className={styles.contactIcon} />
              <span>{formData.mobile_number}</span>
            </div>
          )}
          {formData?.linkedin && (
            <div className={styles.contactItem}>
              <img src={icon4} alt="linkedin" className={styles.contactIcon} />
              <span>{formData.linkedin}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Experience = ({ experience, resumeBuilder }) => {
  if (!experience?.length) return null;

  // Extract total experience text cleanly
  const rawExpText = resumeBuilder?.total_work_experience
    ? getWorkExpText(resumeBuilder?.total_work_experience)?.trim()
    : "";

  // Make sure it's not just "years" or empty before wrapping in parentheses
  const totalExperience =
    rawExpText && rawExpText !== "years" && rawExpText !== "year"
      ? `(${rawExpText})`
      : "";

  return (
    <div className={styles.mainSection}>
      <h2 className={styles.mainSectionTitle}>
        <SectionMarkerIcon />
        WORK EXPERIENCE {totalExperience}
      </h2>

      {experience.map((job, idx) => {
        // Fall back to job object if additional_fields is missing
        const jobData = job?.additional_fields || job;

        const startDate = getStartData(jobData);
        const endDate = getEndData(jobData);

        // Build the date display string safely
        let dateDisplay = "";
        if (startDate && endDate) {
          dateDisplay =
            endDate === "Present"
              ? `${startDate} - Present`
              : `${startDate} - ${endDate}`;
        } else if (startDate) {
          dateDisplay = startDate;
        } else if (endDate) {
          dateDisplay = endDate;
        }

        const position =
          jobData?.position || jobData?.designation || jobData?.job_title;
        const company =
          jobData?.company_name || jobData?.company || jobData?.organization;
        const location = jobData?.location || jobData?.city;
        const details = jobData?.details;

        return (
          <div className={styles.experienceItem} key={idx}>
            <div className={styles.experienceHeader}>
              <div>
                {position && <h3 className={styles.jobPosition}>{position}</h3>}
                {company && <h4 className={styles.company}>{company}</h4>}
              </div>
            </div>

            <div className={styles.dateLocation}>
              {dateDisplay && <div className={styles.date}>{dateDisplay}</div>}
              {location && <div className={styles.location}>{location}</div>}
            </div>

            {details && (
              <ul className={styles.experienceList}>
                {toArray(details, "\n").map((detail, i) => (
                  <li key={i}>{detail}</li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

/**
 * Helper function to safely extract start and end dates/years from education objects
 */
const formatEducationDate = (fields) => {
  if (!fields) return "";

  // Check common field names for start date / year
  const start =
    fields.start_year ||
    fields.startYear ||
    fields.start_date ||
    fields.fromDate ||
    fields.from_year;

  // Check common field names for end date / year / passout year
  const end =
    fields.end_year ||
    fields.endYear ||
    fields.end_date ||
    fields.toDate ||
    fields.to_year ||
    fields.passout_year ||
    fields.passing_year ||
    fields.year_of_passing ||
    fields.completion_year;

  // If currently studying / pursuing
  const isPursuing =
    fields.currently_studying ||
    fields.is_current ||
    fields.pursuing ||
    fields.currently_pursuing;

  // 1. Both start and end exist
  if (start && end) {
    return `${start} - ${end}`;
  }

  // 2. Start exists and is currently studying
  if (start && isPursuing) {
    return `${start} - Present`;
  }

  // 3. Only start exists
  if (start) {
    return `${start}`;
  }

  // 4. Only passing/end year exists (common for degrees/diplomas)
  if (end) {
    return `${end}`;
  }

  // 5. Try existing helper functions as a final fallback
  const startFromHelper = getStartData(fields);
  const endFromHelper = getEndData(fields);

  if (
    startFromHelper &&
    endFromHelper &&
    startFromHelper !== "undefined" &&
    endFromHelper !== "undefined"
  ) {
    return `${startFromHelper} - ${endFromHelper}`;
  }

  return ""; // Return empty string instead of "undefined - undefined"
};

const Education = ({ educations }) => {
  if (!educations?.length) return null;

  return (
    <div className={styles.mainSection}>
      <h2 className={styles.mainSectionTitle}>
        <SectionMarkerIcon />
        EDUCATION
      </h2>
      {educations.map((education, idx) => {
        const fields = education?.additional_fields || education;

        const degreeTitle =
          fields?.title ||
          fields?.degree ||
          fields?.qualification ||
          fields?.course ||
          "Degree / Qualification";

        const schoolName =
          fields?.university_college ||
          fields?.university ||
          fields?.college ||
          fields?.school ||
          fields?.institution ||
          "University / School";

        const dateRange = formatEducationDate(fields);

        return (
          <div className={styles.educationItem} key={idx}>
            <h3 className={styles.degree}>{degreeTitle}</h3>
            <h4 className={styles.school}>{schoolName}</h4>
            {dateRange && (
              <div className={styles.educationDate}>{dateRange}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
const SectionMarkerIcon = () => (
  <span className={styles.icon}>
    <span className={styles.sectionMarkerIcon}>
      <span className={styles.sectionMarkerIconOuter}></span>
      <span className={styles.sectionMarkerIconInner}></span>
    </span>
  </span>
);

const ResumeTemplateProfessional = ({
  formData,
  jobLocations,
  experiences,
  certifications,
  qualifications,
}) => {
  // Use the same data structure as ResumeTemplateModern.js
  const languages = formData?.languages_known;
  const awards = formData?.awards;
  const interests = formData?.hobbies; // Use hobbies instead of interests

  return (
    <div className={styles.resume}>
      <div className={styles.container}>
        {/* Left Sidebar */}
        <div className={styles.sidebar}>
          <ProfileImage formData={formData} />
          <Skills skills={formData?.skills} />
          <Languages languages={languages} />
          <Certificates certifications={certifications} />
          <Awards awards={awards} />
          <Interests interests={interests} />
        </div>

        {/* Main Content */}
        <div className={styles.mainContent}>
          <Header formData={formData} jobLocations={jobLocations} />
          <Experience experience={experiences} resumeBuilder={formData} />
          <Education educations={qualifications} />

          {/* Resume Footer */}
          <div className="resume-footer">
            Generated by{" "}
            <a href="https://webvi.in/" style={{ color: "#888" }}>
              <WebsiteLogo />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeTemplateProfessional;
